export class TransactionFilterModel {
  transactions: [];
  labelName: string;
  displayedColumns: [];
}
